var axios = require('axios')

// client
axios.getClientList = function (params, success, callBackError) {
  this.get(process.env.prefix_tenant + '/clients?' + params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.getTimezoneList = function (params, success, callBackError) {
  this.get(process.env.prefix_tenant + '/getTimezoneList')
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.createClient = function (params, success, callBackError) {
  this.post(process.env.prefix_tenant + '/clients/', params)
  .then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.updateClient = function (params, success, callBackError) {
  this.put(process.env.prefix_tenant + '/clients/' + params.uuid, params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

axios.getClientDetail = function (params, success, callBackError) {
  this.get(process.env.prefix_tenant + '/clients/' + params)
  .then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

// aws
axios.clearCache = function (params, cancel, success, callBackError) {
  this.post(process.env.prefix_tenant + '/aws', params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

// get client list by me
axios.getClientsByMe = function (success, callBackError) {
  this.get(process.env.prefix_tenant + '/me/clients')
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

// get config client
axios.getConfigClient = function (params, success, callBackError) {
  this.get(process.env.prefix_tenant + '/config' + params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}


// get config client
axios.getContentClient = function (success, callBackError) {
  this.get(process.env.prefix_tenant + '/content')
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

// post verify Otp
axios.verifyOtp = function (params, success, callBackError) {
  this.post(process.env.prefix_tenant + '/otp', params)
      .then(response => {
        success(response)
      }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.updateContentClient = function (params, success, callBackError) {
  this.post(process.env.prefix_tenant + '/content', params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

axios.checkUser = function (params, success, callBackError) {
  this.post(process.env.prefix_tenant + '/check-authentication',params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.updateStoresForUser = function (params, success, callBackError) {
  this.post(process.env.prefix_tenant + '/user-stores', params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

// ERROR MESSAGES

axios.getListErrorService = function (params, success, callBackError) {
  this.get(process.env.prefix_tenant + '/error-services/?' + params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getListErrorMessage = function (params, success, callBackError) {
  this.get(process.env.prefix_tenant + '/error-messages/?' + params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getDetailErrorMessage = function (params, success, callBackError) {
  this.get(process.env.prefix_tenant + '/error-messages/' + params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.createErrorMessage = function (params, success, callBackError) {
  this.post(process.env.prefix_tenant + '/error-messages/', params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.updateErrorMessage = function (params, success, callBackError) {
  this.put(process.env.prefix_tenant + '/error-messages/' + params.uuid, params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

// REASON STATUS

axios.getListReasonStatus = function (params, success, callBackError) {
  this.get(process.env.prefix_tenant + '/reason-status?' + params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getDetailReasonStatus = function (params, success, callBackError) {
  this.get(process.env.prefix_tenant + '/reason-status/' + params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.createReasonStatus = function (params, success, callBackError) {
  this.post(process.env.prefix_tenant + '/reason-status/', params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.updateReasonStatus = function (params, success, callBackError) {
  this.put(process.env.prefix_tenant + '/reason-status/' + params.uuid, params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

export default axios



// WEBPACK FOOTER //
// ./src/assets/api/Tenant.js